import React from 'react'

// We need to use native events in Popover content instead of React
// synthetic events, because of the way that GoogleDivOverlay has to
// steamroll events with stopPropagation in order to prevent google
// maps from freaking out.
//
// unfortunate, but I wasted a full afternoon trying to fix this a
// different way and couldn't
export class NativeClickImg extends React.Component {
  componentDidMount () {
    this._ref.addEventListener('click', this._onClick)
  }

  componentWillUnmount () {
    this._ref.removeEventListener('click', this._onClick)
  }

  _onClick = (e) => {
    this.props.onClick && this.props.onClick(e)
  }

  render () {
    const { onClick, ...props } = this.props
    return <img style={{ cursor: 'pointer' }} ref={r => { this._ref = r }} {...props} />
  }
}
